export const SETTINGS_TABS = [
  { id: "company", label: "Company Info" },
  { id: "locations", label: "Stores" },
  // { id: "reminders", label: "Reminders" },
  // { id: "notifications", label: "Notifications" },
  // { id: "workflow", label: "Workflow" },
  { id: "billing", label: "Billing" },
  { id: "license", label: "License Info", roles: ["owner"] },
  { id: "termsInfo", label: "Terms & conditions" },
  { id: "rolesAccess", label: "Roles & Access" },
  { id: "installationMembers", label: "Installation Members" },
];

export const DEFAULT_COMPANY_INFO = {
  name: "Space Designs",
  email: "info@spacedesigns.com",
  phone: "+91 9800000000",
  address: "vijayawada, Andhra Pradesh,",
  gst: "36ABCDE1234F1Z5",
  website: "www.spacedesigns.net",
};




